import { useState } from 'react'
import { sortBy } from 'lodash'
import { useHistory } from 'react-router-dom'
import { useFormikContext } from 'formik'

import Modal from 'components/Modal'
import MultiSelectFilter from 'components/MultiSelectFilter'
import DisplayCategoryLabel from 'components/Item/Form/Labels/DisplayCategoryLabel'

import { FUSE_OPTIONS } from 'utils/fuseSettings'
import { displayCategoriesFilterOption } from 'resources'

const DisplayCategoriesDrawer = ({
  setFormStep,
  isLoading,
  displayCategories,
}) => {
  const history = useHistory()

  const { values, setFieldValue } = useFormikContext()

  const alphabeticllySortedDisplayCategories = sortBy(
    displayCategories,
    'name'
  )

  const [selectedItemsUuids, setSelectedItemsUuids] = useState(
    values?.displayCategoriesAssignedToItem
  )

  const handleChangeCheckbox = (value) => {
    setSelectedItemsUuids(value)
  }

  const onCloseModal = () => {
    history.push({ state: { itemUuid: null } })
  }

  const onClickReturn = () => {
    setFormStep('itemsForm')
  }

  const handleSave = () => {
    setFieldValue(
      'displayCategoriesAssignedToItem',
      selectedItemsUuids
    )
    setFormStep('itemsForm')
  }

  return (
    <Modal
      title="Display Categories"
      isReturnIcon
      onClose={onCloseModal}
      onClickReturn={onClickReturn}
      className="-narrow"
      isLoading={isLoading}
      onRequestClose={onCloseModal}
    >
      <MultiSelectFilter
        label={(item) => (
          <DisplayCategoryLabel
            item={item}
            handleChangeCheckbox={handleChangeCheckbox}
            selectedItemsUuids={selectedItemsUuids}
          />
        )}
        items={alphabeticllySortedDisplayCategories}
        itemsUuids={selectedItemsUuids}
        handleSave={handleSave}
        handleChangeCheckbox={handleChangeCheckbox}
        fuseSettings={FUSE_OPTIONS}
        doubleToggleButtonOptions={displayCategoriesFilterOption}
        checkboxIndeterminateLabel="All Display Categories"
      />
    </Modal>
  )
}

export default DisplayCategoriesDrawer
